import { Navigate } from "react-router-dom";
import useStudentAuth from "../hooks/useStudentAuth";
import useAdminAuth from "../hooks/useAdminAuth";

export default function PublicRoute({ children }) {
  const isStudentLoggedIn = useStudentAuth();
  const isAdminLoggedIn = useAdminAuth();
  if (isStudentLoggedIn && !isAdminLoggedIn) {
    return <Navigate to="/course" />;
  } else if (!isStudentLoggedIn && isAdminLoggedIn) {
    return <Navigate to={"/admin/dashboard"} />;
  } else {
    return children;
  }
}
